const { Node } = require('slate');

const getTextContent = ({ value }) => value.map((node) => Node.string(node));

module.exports = getTextContent;
